import {AppVersion} from '../../types/AppVersion';
import {AppFilterStrategy} from './AppFilterStrategy';

/**
 * Filter strategy for filtering apps by installation status.
 * When active (true), only shows installed apps.
 */
export class InstalledFilterStrategy extends AppFilterStrategy<boolean> {
  public matches(app: AppVersion, filterValue: boolean | undefined): boolean {
    if (!this.isActive(filterValue)) {
      return true;
    }
    return !!app.installed;
  }
}
